declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';

@Component({
    selector: 'triggeredit',
    templateUrl: './triggeredit.modal.html',
    styleUrls: ['./triggeredit.modal.scss']
})

export class NgbTriggerEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    @Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    @Input() Eggsourcetype: string;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    private isvisibleendo: boolean = true;
    public EggSourceType: string;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveFollicularScanDetailRequest: SaveFollicularScanDetailRequest;
    CurrentSaveFollicularScanOvaryDetailRequest: SaveFollicularScanOvaryDetailRequest;
    CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
    CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    CurrentSaveFollicularPickupsDetailV2Request: SaveFollicularPickupsDetailV2Request;
    CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveFollicularScanDetailRequest = new SaveFollicularScanDetailRequest();

      this.CurrentSaveFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularScanOvaryDetailRequest = new SaveFollicularScanOvaryDetailRequest();
      this.CurrentSaveFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
      this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveFollicularPickupsDetailV2Request = new SaveFollicularPickupsDetailV2Request();

      this.CurrentSaveFollicularPickupsDetailV2Request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
      this.LoadOvariesData();
      this.LoadCycles();
     

      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }
    CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
    FollicularPickupEndInfo: FollicularPickUpsByCodeController;
    CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

    LoadOvariesData() {
        //alert("ScansData")
        this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetFollicularPickUpsByCodeController();
    }

    GetFollicularPickUpsByCodeController() {
        // this.StartRefreshing();
        this.spinner.show();
        this.CurrentFollicularPickUpsByCodeRequest.ConditionalOperator = 20;
        this.CurrentFollicularPickUpsByCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.CycleCode;
        //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
        //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
        //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
        //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
        //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
        //alert(this.FormattedCode);
        this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
                    this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
                    if (this.FollicularPickupEndInfo.OvulationTriggerDate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.OvulationTriggerDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.OvulationTriggerDate2 != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate2);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ActivityDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.ExpiryDate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ExpiryDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.ExpiryDate2 != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.ExpiryDate2);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.ExpiryDate2 = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    if (this.FollicularPickupEndInfo.OvumPickupdate != null) {
                        var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPickupdate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.OvumPickupdate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }

                    //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
                    //  = this.FollicularScanEndInfo.EndometriumThickness;
                    //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
                    //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    // this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    
                    this.spinner.hide();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    FollicularData: TreatmentCycleStatusController[];
  FollicularData2: TreatmentCycleStatusController;
  PickupData: TreatmentCycleStatusController[];
  PickupData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.FollicularData = this.ApiResData.Result;
                    var Follicularlist = this.FollicularData.filter(
                        function (b) {
                            return b.PhaseActivity == "Follicular Scans";
                        });
                    this.FollicularData = Follicularlist;
                  this.FollicularData2 = this.FollicularData[0];
                  this.PickupData = this.ApiResData.Result;
                  var Pickuplist = this.PickupData.filter(
                    function (c) {
                      return c.PhaseActivity == "Pickup";
                    });
                  this.PickupData = Pickuplist;
                  this.PickupData2 = this.PickupData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //  this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
      // alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }

    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    SaveOvulationtrigger(CurrentFollicularPickupDetails: FollicularPickUpsByCodeController) {
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = CurrentFollicularPickupDetails.TriggerTime;

        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = CurrentFollicularPickupDetails.OvumPlannedPickupDate;

        //this.CurrentSaveFollicularPickupsDetailV2Request.ActualDate = CurrentFollicularPickupDetails.ActualPickupDate;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ActualTime = CurrentFollicularPickupDetails.ActualPickupTime;
        //this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = CurrentFollicularPickupDetails.Surgeon;
       
        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = CurrentFollicularPickupDetails.Dose;
        //this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode = this.FollicularPickupEndInfo.MedicineCode;
        //this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode2 = this.FollicularPickupEndInfo.MedicineCode2;

    }
    onSubmit() {
        this.spinner.show();
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate = new Date(this.parserFormatter.format(this.OvulationTriggerDate));
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityDate2 = new Date(this.parserFormatter.format(this.ActivityDate));
        //this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dose;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime = this.FollicularPickupEndInfo.OvulationTriggerTime;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityTime2 = this.FollicularPickupEndInfo.OvulationTriggerTime2;
        this.CurrentSaveFollicularPickupsDetailV2Request.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        this.CurrentSaveFollicularPickupsDetailV2Request.Dosage = this.FollicularPickupEndInfo.Dosage;
        this.CurrentSaveFollicularPickupsDetailV2Request.Dosage2 = this.FollicularPickupEndInfo.Dosage2;
        this.CurrentSaveFollicularPickupsDetailV2Request.Batch = this.FollicularPickupEndInfo.BatchNo;
        this.CurrentSaveFollicularPickupsDetailV2Request.Batch2 = this.FollicularPickupEndInfo.BatchNo2;
        this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate = new Date(this.parserFormatter.format(this.ExpiryDate));
        this.CurrentSaveFollicularPickupsDetailV2Request.ExpiryDate2 = new Date(this.parserFormatter.format(this.ExpiryDate2));
        this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType = this.FollicularPickupEndInfo.triggertype;
        if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Dual Trigger' || this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Double Trigger') {
            this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 10;
        }
        else if (this.CurrentSaveFollicularPickupsDetailV2Request.TriggerType == 'Single Dose') {
            this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
        }
        //this.CurrentSaveFollicularPickupsDetailV2Request.
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        this.CurrentSaveFollicularPickupsDetailV2Request.ActivityApprovedEmpCode2 = AppData.Instance().UserLoginDetails.EmployeeCode;

        //this.CurrentSaveFollicularPickupsDetailV2Request.TreatmentCycle = this.FollicularPickupEndInfo.PickUpTreatmentCycle;
        //this.CurrentSaveFollicularPickupsDetailV2Request.FollicularGrowth = this.FollicularPickupEndInfo.FollicularGrowth;
        //this.CurrentSaveFollicularPickupsDetailV2Request.CycleActivity = this.FollicularPickupEndInfo.PickupCycleActivity;
        //this.CurrentSaveFollicularPickupsDetailV2Request.ConditionalOperator = 2;
        this.actorservice.SaveFollicularPickupsDetailV2(this.CurrentSaveFollicularPickupsDetailV2Request)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.GetActorEducationInfoController();
                        //this.GetResourceIdentificationByDateInfoController();
                        // alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        //this.activeModal.close();
                        //this.clearData();
                        //this.LoadScansData();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.spinner.hide();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();


                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                        this.spinner.hide();
                    }
                }
            );


    }
    onAssignedToActorCode2(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCode3(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineCode2 = event;
            this.CurrentSaveFollicularPickupsDetailV2Request.MedicineName2 = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    //printfollicular() {
    //  this.router.navigate(['print/folliculargrowth', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
    //}
    printfollicular2() {
        this.printService.printDocument("follicularscans",
            {
                ScanCodeData: this.FollicularGrowthCode, CycleCode: this.CycleCode, PatientCode: this.PatientCode, CycleType: this.SelectedpatientDetails.CycleType, Doc: this.DOC, DocDate: this.SelectedpatientDetails.ProtocolStartDate, CycleActivity: this.ActivityCode, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo,
                DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
                GradingModelData: this.GradingModel, TcModelData: this.SelectedpatientDetails.TCModelName
            },

        );

        //    this.router.navigate(['print/follicularscans', { ScanCodeData: this.SelectedpatientDetails.FollicularGrowthCode, CycleCode: this.SelectedpatientDetails.TreatmentCycle, PatientCode: this.SelectedpatientDetails.PatientCode, Doc: this.SelectedpatientDetails.DOC, DocDate: this.SelectedpatientDetails.DocDate, CycleActivity: this.SelectedpatientDetails.CycleActivity, Owner: this.SelectedpatientDetails.OwnerName, FormattedCode: this.SelectedpatientDetails.OwnerFormattedCode, Protocolst: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEd: this.SelectedpatientDetails.ProtocolEndDate, Protocol: this.SelectedpatientDetails.ProtocolName, Infertility: this.SelectedpatientDetails.InfertilityType, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, CycleNo: this.SelectedpatientDetails.CycleNo }]);
    }

    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }





}
